module.exports = __webpack_public_path__ + "img/event_banner.d80e74c8.png";